import { ClaimFlight } from 'pages/miles/Claim/claim.interface';

export enum MilageStatus {
  Success = 'Success',
  SuccessfullyRegister = 'SuccessfullyRegister',
  NotMatch = 'NotMatch',
  Invalid = 'Invalid',
}
export interface ContentProps {
  open: boolean;
  status: MilageStatus;
  claimedFlight?: ClaimFlight[] | [];
  closeModal: () => void;
}
